export const degrees = [
  {
    value: 'bs-mecheng',
    college: 'coe',
    program: 'Mechanical and Industrial Engineering',
    degree: 'B.S. Mechanical Engineering',
    description: "Mechanical engineering involves the design, development, and manufacture of machinery and devices to transmit power or to convert energy from thermal to mechanical form in order to power the modern world and its machines. Its current practice has been heavily influenced by recent advances in computer hardware and software.",
    link: "http://catalog.northeastern.edu/undergraduate/engineering/mechanical-industrial/bsme/"
  },
  {
    value: 'bs-induseng',
    college: 'coe',
    program: 'Mechanical and Industrial Engineering',
    degree: 'B.S. Industrial Engineering',
    description: "Industrial engineering involves the design and analysis of systems that include people, equipment, and materials and their interactions and performance in the workplace. An industrial engineer collects this information and evaluates alternatives to make decisions that best advance the goals of the enterprise.",
    link: "http://catalog.northeastern.edu/undergraduate/engineering/mechanical-industrial/bsie/"
  },
  {
    value: 'ba-gdesign',
    college: 'camd',
    program: 'Art + Design',
    degree: 'B.F.A. Design',
    description: "Design is the practice-based discipline raising important questions about—and providing significant answers to—how we live. Designers are needed when we don’t know what is needed. Designers propose alternative futures and create new choices using design principles and processes to create, compose, and construct meaning in diverse knowledge fields. Designers seek a broad understanding of principles and systems of perception, communication, and action. Concentrations in design practices are graphic and information design, interaction design, and experience design.",
    link: "http://catalog.northeastern.edu/undergraduate/arts-media-design/art-design/design-bfa/"
  },
  {
    value: 'bs-compsci',
    college: 'khoury',
    program: 'Computer Science',
    degree: 'B.S. Computer Science',
    description: "The Bachelor of Science in Computer Science focuses on the fundamentals of program design, software development, computer organization, systems and networks, theories of computation, principles of languages, and advanced algorithms and data.",
    link: "http://catalog.northeastern.edu/undergraduate/computer-information-science/computer-science/bscs/"
  },
  {
    value: 'ba-compsci',
    college: 'khoury',
    program: 'Computer Science',
    degree: 'B.A. Computer Science',
    description: "The Bachelor of Arts in Computer Science offers a similar curriculum to the BS, with slightly fewer CS requirements to allow students to study a foreign language and have a wider choice of electives.",
    link: "http://catalog.northeastern.edu/undergraduate/computer-information-science/computer-science/bacs/"
  },
  {
    value: 'bs-csma',
    college: 'khoury',
    program: 'Computer Science',
    degree: 'B.S. Computer Science/Media Art',
    description: "The computer science and media arts combined major is ideal for creative students who love technology. Students will acquire a solid foundation in both fields through curriculum that spans photography, animation, video, database design, computer graphics, and human-computer interaction.",
    link: "http://catalog.northeastern.edu/undergraduate/computer-information-science/computer-information-science-combined-majors/computer-science-media-arts-bs/"
  }
];

export const comp_sci_data = [
  {
    courseNumber: "CS 1800",
    title: "Discrete Structures",
    status: 0,
    grade: "B ",
    credits: 5,
  },
  {
    courseNumber: 'CS 2500',
    title: 'Fundamentals of Computer Science 1',
    status: 0,
    grade:'B-',
    credits: 5
  },
  {
    courseNumber: 'CS 2510',
    title: 'Fundamentals of Computer Science 2',
    status: 1,
    grade: '-',
    credits: 5
  }
];

export const media_arts_req = [
  {
    courseNumber: "ART 1120",
    title: "Observational Drawing",
    status: 0,
    grade: "B ",
    credits: 4
  },
  {
    courseNumber: 'ARTF 1141 - ARTF 1149',
    title: 'Complete one course in the range',
    status: 2,
    grade: '-',
    credits: 4
  },
  {
    courseNumber: 'ARTF 1122',
    title: '2D Fundamentals: Surface and Drawing',
    status: 0,
    grade: 'A',
    credits: 4
  },
  {
    courseNumber: 'ARTF 1124',
    title: '3D Fundamentals: Surface and Drawing',
    status: 0,
    grade: 'C+',
    credits: 4
  },
  {
    courseNumber: 'ARTF 1125',
    title: '3D Tools',
    status: 0,
    grade: 'C+',
    credits: 1
  }

]

export const media_arts_electives = [
  {
    courseNumber: 'ARTD 2360',
    title: 'Photo Basics',
    status: 0,
    grade: 'B',
    credits: 4
  },
  {
    courseNumber: 'ARTD 2370',
    title: 'Animation Basics',
    status: 1,
    grade: '-',
    credits: 4
  },
  {
    courseNumber: 'ARTD 2380',
    title: 'Video Basics',
    status: 1,
    grade: '-',
    credits: 4
  }
];

export const overview_req = [{
  courseNumber: 'CS 1200',
  title: 'Leadership Skills',
  status: 0,
  grade: 'P',
  credits: '1'
}, 
{
  courseNumber: 'CS 1210',
  title: 'Professional Development for Khoury Coop',
  status: 0,
  grade: 'P',
  credits: '1'
}
];

export const nupath = [
  {
  courseNumber: '-',
  title: 'Engaging with the Natural and Designed World',
  status: 2,
  grade: '-',
  credits: '-'
},
{
  courseNumber: 'ARTF 1120',
  title: 'Observational Drawing',
  status: 0,
  grade: 'B',
  credits: 4
},
{
  courseNumber: '-',
  title: 'Conducting Formal and Quantitative Reasoning',
  status: 2,
  grade: '-',
  credits: '-'
},
{
  courseNumber: '-',
  title: 'Analyzing and Using Data',
  status: 2,
  grade: '-',
  credits: '-'
},
{
  courseNumber: 'ENG 1100',
  title: 'Writing in the First Year',
  status: 0,
  grade: 'A',
  credits: '4'
},
{
  courseNumber: '-',
  title: 'Advanced Writing',
  status: 2,
  grade: '-',
  credits: '-'
},
{
  courseNumber: '-',
  title: 'Integrating Knowledge and Skills Through Experience',
  status: 2,
  grade: '-',
  credits: '-'
}
]
